module.exports = __webpack_public_path__ + "static/media/uatp.09e246af.png";